import React, { Component } from 'react';

import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Heading from 'grommet/components/Heading';
import Image from 'grommet/components/Image';

import CustomArticle from './CustomArticle';
import SANIcon from 'grommet/components/icons/base/Storage';
import {said} from '../../AppConfig';

class RecomSoln extends Component {

  constructor(props) {
    super(props);
    this.state = {currentObj: this.props.RoleData};
  }

  componentWillReceiveProps(nextProps, nextState){
      if(this.props.RoleData !== nextProps.RoleData){
          this.setState({currentObj: nextProps.RoleData});
      }
  }

  render() {
      let RoleObj = this.state.currentObj;
      let MainServerName = null;
      let ProcDetails = null;
      let StorageDetails = null;
      let StorageVolumeDetails = null;
      let MemoryDetails = null;
      let MemoryDIMMDetails = null;

      let rlName = '';
      if(RoleObj['@DisplayName'] === undefined || RoleObj['@DisplayName'] === ''){
         rlName = RoleObj['RoleName'];
      }else{
         rlName = RoleObj['@DisplayName'];
      }
      
      if( rlName !== 'SharedStorage' && rlName !== 'Shared Storage' ){
       if(!Array.isArray(RoleObj['Processor']))   
       {
        if(RoleObj['Processor']!==undefined && RoleObj['Processor'] !== null && RoleObj['Processor'] !== '' ){
            MainServerName = RoleObj['Processor'];
        }
       }
       if(!Array.isArray(RoleObj['ProcessorDetails']))   
       {
        if( RoleObj['ProcessorDetails']!==undefined && RoleObj['ProcessorDetails'] !== null && RoleObj['ProcessorDetails'] !== ''){
            ProcDetails = RoleObj['ProcessorDetails'];
        }
       }
        if( RoleObj['Memory']!== undefined && (RoleObj['HANA'] === undefined || RoleObj['HANA'] === 'false') && RoleObj['Memory'] !== null && !Array.isArray(RoleObj['Memory']) ){
            MemoryDetails = RoleObj['Memory'] + ' (Per Server)';
        }else if(RoleObj['Memory']!== undefined || RoleObj['MemoryDIMMS']!== undefined){
            if( RoleObj['Memory'] !== undefined && RoleObj['Memory'] !== null && RoleObj['Memory'] !== '' && !Array.isArray(RoleObj['Memory']) ){
                MemoryDetails = RoleObj['Memory'];
            }
              if(RoleObj['MemoryDIMMS'] !== '' && RoleObj['MemoryDIMMS']!== undefined && RoleObj['MemoryDIMMS']!== null &&!Array.isArray(RoleObj['MemoryDIMMS'])){
                MemoryDIMMDetails = RoleObj['MemoryDIMMS'];
              }
              MemoryDetails = RoleObj['Memory'];
              MemoryDIMMDetails = RoleObj['MemoryDIMMS'];
        }
        if(RoleObj['Storage'] !== undefined && RoleObj['Storage'] !== null && RoleObj['Storage'] !== '' && RoleObj['Storage'].trim() !== 'GB Storage' && 
            RoleObj['Storage'].length !== 0 ){
                if(RoleObj['Storage']==="HPE SAP HANA Scale-up Storage" || RoleObj['Storage']==="HPE SAP HANA BC/TDI D3710 Storage"){
                    StorageDetails = RoleObj['Storage']+" "+RoleObj['StorageNode'];
                }else{
                    StorageDetails = RoleObj['Storage'];
                }    
        }
      if(RoleObj['StorageVolume'] !== undefined && RoleObj['StorageVolume'] !== '' && RoleObj['StorageVolume'].trim() !== 'GB Storage' && RoleObj['StorageVolume'] !== null ){
          StorageVolumeDetails = RoleObj['StorageVolume'];
      }
      }

      let DASData = '';
      let SANData = '';

      if(RoleObj.DAS !== null && RoleObj.DAS !== '' && RoleObj.DAS.length !== 0 ){           
       // DAS variables
        let DASIntOnlineSpareQty = 0;
        let DASExtOnlineSpareQty = 0;
        let DASExtArrayType = '';
        let DAS_InternalStorages = [];      
        let DAS_ExternalStorages = [];

        let DASIntDiskQty = 0;
        let DASExtDiskQty = 0;       
        let ServerCount;
       // if DAS.TableData is available
        if(RoleObj.DAS.TableData !== undefined){ 
            if(RoleObj.ServerName !== undefined)
            {
                ServerCount = parseInt(RoleObj.ServerName['@Qty'], 10);
            }
            else ServerCount = 1;
            if ( Array.isArray( RoleObj.DAS.TableData ) ) {           
            // if DAS.TableData is an array                
                RoleObj.DAS.TableData.map( (DASobj, index ) => {
                    if(DASobj.ArrayType === undefined){                              
                        DASIntDiskQty += parseInt(DASobj.DiskQty, 10);
                        DASIntOnlineSpareQty += parseInt(DASobj.OnlineSpare, 10);
                        if(DASobj.DiskQty === '1'){
                            if(DASobj.RaidLevel !== undefined){
                            DAS_InternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel);
                            }
                            else if(said==="EPAvNext"){
                                DAS_InternalStorages.push(DASobj.VolumeName+" -"+DASobj.DiskQty+" Disk ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");
                            }
                        }else{
                            if(DASobj.VolumeName ==="Data (D)"){
                                let content = DASobj.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";
                                if(DASobj.RAIDLevel!== undefined && DASobj.RAIDLevel.trim().length>0)
                                {
                                    content += DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";
                                }                                

                                 DAS_InternalStorages.push(content);
                            }
                            else   if(DASobj.VolumeName ==="OS (Os)"){
                                 let content =DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";
                                 if(DASobj.RAIDLevel!== undefined && DASobj.RAIDLevel.trim().length>0)
                                    {
                                        content += DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";
                                    }
                                 DAS_InternalStorages.push(content);
                            }
                             else   if(DASobj.VolumeName ==="Tenant (T)"){
                                 let content =DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";
                                 if(DASobj.RAIDLevel!== undefined && DASobj.RAIDLevel.trim().length>0)
                                    {
                                        content += DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";
                                    }
                                 DAS_InternalStorages.push(content);
                            }
                            else{                                 
                                 let content =DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";
                                 if(DASobj.RAIDLevel!== undefined && DASobj.RAIDLevel.trim().length>0)
                                    {
                                        content += DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";
                                    }
                                 DAS_InternalStorages.push(content);                            
                            }
                           
                        }
                    }
                    else{
                        DASExtArrayType = DASobj.ArrayType;
                         let ServerQty = ""
                        if(said === "EPAvNext") {
                            if(RoleObj['Processor'].indexOf("Synergy") === -1) {
                                DASExtDiskQty += parseInt(DASobj.DiskQty, 10);
                            } else {  
                                    if(DASobj["ArrayType"] === "D3940") {
                                        
                                        ServerQty = parseInt(DASobj.DiskQty, 10) / parseInt(RoleObj.ServerName["@Qty"], 10);
                                       DASExtDiskQty += parseInt(ServerQty, 10);
                                    //DASobj.DiskQty=ServerQty.toString();
                                    }
                                    else {
                                         DASExtDiskQty += parseInt(DASobj.DiskQty, 10);
                                      ServerQty = parseInt(DASobj.DiskQty, 10)
                                    }
                            }

                        } else {
                            DASExtDiskQty += parseInt(DASobj.DiskQty, 10);
                            ServerQty = parseInt(DASobj.DiskQty, 10)
                        }

                        DASExtOnlineSpareQty += parseInt(DASobj.OnlineSpare, 10);
                        if(DASobj.DiskQty === '1'){
                            DAS_ExternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel);
                        }else{
                             let content =DASobj.VolumeName+" - "+ServerQty.toString()+" Disks ("+DASobj.Disk+") ";
                                    if(DASobj.RAIDLevel!== undefined && DASobj.RAIDLevel.trim().length>0)
                                    {
                                        content += DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";
                                    }
                            DAS_ExternalStorages.push(content);              
                        }
                    }
                });
            }else{
            // if DAS.TableData is an object
                if(RoleObj.DAS.TableData.ArrayType === undefined){ 
                    DASIntDiskQty += parseInt(RoleObj.DAS.TableData.DiskQty, 10);
                    DASIntOnlineSpareQty += parseInt(RoleObj.DAS.TableData.OnlineSpare, 10);
                    if(RoleObj.DAS.TableData.DiskQty === '1'){
                        //DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
                        DAS_InternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
                    }else{
                        DAS_InternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RAIDLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
                    }
                }else{
                    DASExtArrayType = RoleObj.DAS.TableData.ArrayType;
                    DASExtDiskQty += parseInt(RoleObj.DAS.TableData.DiskQty, 10);
                    DASExtOnlineSpareQty += parseInt(RoleObj.DAS.TableData.OnlineSpare, 10);
                    if(RoleObj.DAS.TableData.DiskQty === '1'){
                        DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
                    }else{                            
                        DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+RoleObj.DAS.TableData.DiskQty+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RAIDLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
                    }
                }
            } 
        }else{
       // if DAS.TableData is not available          
          RoleObj.DAS.map( (DASobj, index) => {               
            if(DASobj.ArrayType === undefined){                              
               DASIntDiskQty += parseInt(DASobj.DiskQty, 10);
               DASIntOnlineSpareQty += parseInt(DASobj.OnlineSpare, 10);
               if(DASobj.DiskQty === '1'){
                    DAS_InternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel+" Spares ("+DASobj.OnlineSpare+") ");
               }else{
                    DAS_InternalStorages.push(DASobj.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");
               }
            }else{
               DASExtArrayType = DASobj.ArrayType;
               DASExtDiskQty += parseInt(DASobj.DiskQty, 10);
               DASExtOnlineSpareQty += parseInt(DASobj.OnlineSpare, 10);
               if(DASobj.DiskQty === '1'){
                    DAS_ExternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel+" Spares ("+DASobj.OnlineSpare+") ");
               }else{
                    DAS_ExternalStorages.push(DASobj.VolumeName+" - "+DASobj.DiskQty+" Disks ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");              
               }
            }                 
          });      
        } 
        
        let DASIntHeader = "Disk(DAS) - "+DASIntDiskQty/ServerCount+" Disks Spares ("+DASIntOnlineSpareQty+") (Per Server)";
        
        let DASExtHeader = '';

        if(RoleObj.DAS.StorageBoxes !== undefined){
            DASExtHeader = "Disk(DAS) - "+DASExtDiskQty+" Disks ("+RoleObj.DAS.StorageBoxes+" x "+DASExtArrayType+")";
        }else{
            DASExtHeader = "Disk(DAS) - "+DASExtDiskQty+" Disks ("+DASExtArrayType+") Spares ("+DASExtOnlineSpareQty+") (Per Server)";
        }
        
        // DASExtHeader = "Disk(DAS) - "+DASExtDiskQty+" Disks ("+DASExtArrayType+") Spares ("+DASExtOnlineSpareQty+") (Per Server)";
        
        let DASIntContent = '';
        let DASExtContent = '';

        if(DASIntDiskQty !== 0){
            DASIntContent = <CustomArticle ArticleBackgroundColor='light-2'
                               ContentBackgroundColor='light-1'
                               title={DASIntHeader}
                               titleIcon={<SANIcon size='small' colorIndex='#69506f' />}
                               content={<Box>
                                            { DAS_InternalStorages.map((value, index) => {
                                                return <li key={index} style={{maxWidth: '100%'}}>{value}</li>
                                              })
                                            } 
                                        </Box>} 
            />        
        }

        if(DASExtDiskQty !== 0){
            DASExtContent = <CustomArticle ArticleBackgroundColor='light-2'
                               ContentBackgroundColor='light-1'
                               title={DASExtHeader}
                               titleIcon={<SANIcon size='small' colorIndex='#69506f' />}
                               content={<Box>
                                            { DAS_ExternalStorages.map((value, index) => {
                                                return <li key={index} style={{maxWidth: '100%'}}>{value}</li>
                                              })
                                            } 
                                        </Box>} 
            />        
        }
        
        DASData = <Box id='CustomArticlesContainer' margin='none' pad={{between: 'small'}}>
                       {DASIntContent}
                       {DASExtContent}
                  </Box>
      }

      // if SAN has Nimble Storage 
      
        if(RoleObj.SAN!==undefined && RoleObj.SAN['TableData'] !== undefined){              
        // SAN variables
            //let SANExtOnlineSpareQty = 0;
            let SANExtArrayQty = '';     
            let SANExtArrayType = '';    
            let SAN_ExternalStorages = [];
            let SANExtDiskQty = 0;
                
        // if SAN.TableData is not available
            let SANExtHeader = '';
            let SANExtContent = '';

            if(RoleObj.SAN.TableData === undefined){
            
            }else{

                var nimbleor3par='';
                // if SAN.TableData is available 
                
                // if SAN.Nimble is available 
                if(RoleObj.SAN['NimbleStorage'] !== undefined) {

                    SANExtHeader = RoleObj.SAN.StorageBoxes + ' [Nimble] ';

                    if ( Array.isArray(RoleObj.SAN.TableData ) ) {
                    // if SAN.TableData is an array
                        RoleObj.SAN.TableData.map( (SANobj, index ) => {
                            SAN_ExternalStorages.push(SANobj.VolumeName);
                        });
                    }else{
                            SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName);                        
                    } 
                     
                    SANExtContent = <CustomArticle ArticleBackgroundColor='light-2'
                                        ContentBackgroundColor='light-1'
                                        title={SANExtHeader}
                                        titleIcon={<SANIcon size='small' colorIndex='#69506f' />}
                                        content={<Box>
                                                        { SAN_ExternalStorages.map((value, index) => {
                                                            return <li key={index} style={{maxWidth: '100%'}}>{value}</li>
                                                        })
                                                        } 
                                                    </Box>} 
                        />        ;

                }else{
                    
                    SANExtArrayQty = RoleObj.SAN.StorageBoxes;
                    if ( Array.isArray(RoleObj.SAN.TableData ) ) {
                        if(RoleObj.SAN.TableData[0] !== undefined && RoleObj.SAN.TableData[0] !== null)
                        {
                            nimbleor3par = '[ '+RoleObj.SAN.TableData[0]['StorageType']+ ' ]';
                        }

                    // if SAN.TableData is an array
                        RoleObj.SAN.TableData.map( (SANobj, index ) => {
                                SANExtArrayType = SANobj.ArrayType;
                                SANExtDiskQty += parseInt(SANobj.DiskQty, 10);
                                //SANExtOnlineSpareQty += parseInt(SANobj.OnlineSpare, 10);
                                if(SANobj.DiskQty === '1'){
                                    SAN_ExternalStorages.push(SANobj.VolumeName+" - ("+SANobj.Disk+") "+SANobj.RaidLevel);
                                }else{
                                    SAN_ExternalStorages.push(SANobj.VolumeName+" - "+SANobj.DiskQty+" Disks ("+SANobj.Disk+") "+SANobj.RaidLevel);              
                                }
                        });
                    }else{
                    // if SAN.TableData is an object
                        if(RoleObj.SAN.TableData['StorageType'].trim().length>0)
                        {
                             nimbleor3par = '[ '+RoleObj.SAN.TableData['StorageType']+ ' ]';
                        }
                        SANExtArrayType = RoleObj.SAN.TableData.ArrayType;                        
                        SANExtDiskQty += parseInt(RoleObj.SAN.TableData.DiskQty, 10);
                        //SANExtOnlineSpareQty += parseInt(RoleObj.SAN.TableData.OnlineSpare, 10);
                        if(RoleObj.SAN.TableData.DiskQty === '1'){
                            SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName+" - ("+RoleObj.SAN.TableData.Disk+") "+RoleObj.SAN.TableData.RaidLevel);
                        }else{
                            SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName+" - "+RoleObj.SAN.TableData.DiskQty+" Disks ("+RoleObj.SAN.TableData.Disk+") "+RoleObj.SAN.TableData.RaidLevel);
                        }
                    } 

                    
                            
                    SANExtHeader = "Disk(SAN) - "+SANExtDiskQty+" Disks ("+SANExtArrayQty+" x "+SANExtArrayType+")" + nimbleor3par;
                    SANExtContent = '';

                    if(SANExtDiskQty !== 0){
                        SANExtContent = <CustomArticle ArticleBackgroundColor='light-2'
                                        ContentBackgroundColor='light-1'
                                        title={SANExtHeader}
                                        titleIcon={<SANIcon size='small' colorIndex='#69506f' />}
                                        content={<Box>
                                                        { SAN_ExternalStorages.map((value, index) => {
                                                            return <li key={index} style={{maxWidth: '100%'}}>{value}</li>
                                                        })
                                                        } 
                                                    </Box>} 
                        />        
                    }

                }
        }                  

            SANData = <Box id='CustomArticlesContainer' margin='none' pad={{between: 'small'}}>
                        {SANExtContent}
                    </Box>
        }

        let widthproc='80%'
        let paddingproc= '0px 12px'
        if(said==="EPAvNext")
        {
          widthproc="100%";
          paddingproc= '0px 0px';
        }
    return (
      <Box margin='none' pad='none' className='RecomSolnBox' >
        <Box size='xlarge' margin='none' pad='none' align='start' >
            { MainServerName === null ? null
                : <Heading tag='h5' style={{fontWeight: '500'}} margin='none' > {MainServerName} </Heading>
            }
            <Tiles selectable={false} fill={true} flush={true} align='start'
                   direction='row' margin='none' pad={{between: "small"}} >
                { ProcDetails === null || ProcDetails === '' ? null
                : <Tile basis='1/3'  style={{maxHeight:'220px'}}>
                    <Box direction='row' margin='none' pad='small' justify='between' style={{width:'100%'}}>
                      { said !== "EPAvNext" ? <Image style={{height: '100%', width: '20%'}} src="../img/Generic Processor.jpg" />: ""}
                        <Box margin='none' pad={{between:'small'}} style={{width:widthproc, padding: paddingproc}}>
                            <Heading tag='h5' strong={true} margin='none'>Processor</Heading>
                            <Heading tag='h5' style={{fontWeight: '500'}} margin='none' > {ProcDetails} </Heading>
                        </Box>
                    </Box>
                  </Tile>
                }
                { MemoryDetails === null || MemoryDetails === '' ? null 
                : <Tile basis='1/3'  style={{maxHeight:'220px'}}>
                     <Box direction='row' margin='none' pad='small' justify='between' style={{width:'100%'}}>
                       { said !== "EPAvNext" ?  <Image  src="../img/Generic Memory.jpg" style={{height: '100%', width: '20%'}} />:""}
                        <Box margin='none' pad={{between:'small'}} style={{width:widthproc, padding: paddingproc}}>
                            <Heading tag='h5' strong={true} margin='none'>Memory</Heading>
                <Heading tag='h5' style={{fontWeight: '500'}} margin='none' > {MemoryDetails} {MemoryDIMMDetails} </Heading>
                        </Box>
                     </Box>
                  </Tile>
                } 
                {/* MemoryDIMMDetails === null || MemoryDIMMDetails === '' ? null 
                : <Tile basis='1/3'  style={{maxHeight:'220px'}}>
                     <Box direction='row' margin='none' pad='small' justify='between' style={{width:'100%'}}>
                        <Image  src="../img/Generic Memory.jpg" style={{height: '100%', width: '20%'}} />
                        <Box margin='none' pad={{horizontal:'small'}} justify='between' style={{width:'80%'}}>
                            <Heading tag='h5' strong={true} margin='none'>Memory DIMM</Heading>
                            <Heading tag='h5' style={{fontWeight: '500'}} margin='none' > {MemoryDIMMDetails} </Heading>
                        </Box>
                     </Box>
                  </Tile>
                }
                { StorageVolumeDetails === null || StorageVolumeDetails === '' ? null 
                : <Tile basis='1/3'  style={{maxHeight:'220px'}}>
                    <Box direction='row' margin='none' pad='small' justify='between' style={{width:'100%'}}>
                        <Image style={{height: '100%', width: '20%'}} src="../img/Generic Storage.jpg" />
                        <Box margin='none' pad={{horizontal:'small'}} justify='between' style={{width:'80%'}}>
                            <Heading tag='h5' strong={true} margin='none'>Storage Volume</Heading>
                            <Heading tag='h5' style={{fontWeight: '500'}} margin='none' > { StorageVolumeDetails } </Heading>
                        </Box>
                    </Box>
                  </Tile>   
                */  }             
                { StorageDetails === null || StorageDetails === '' ||  said !== 'SAPHANA' ||( said === 'SAPHANA' && this.props.WorkloadType === "TDI") ? null 
                : <Tile basis='1/3'  style={{maxHeight:'220px'}}>
                    <Box direction='row' margin='none' pad='small' justify='between' style={{width:'100%'}}>
                        <Image style={{height: '100%', width: '20%'}} src="../img/Generic Storage.jpg" />
                        <Box margin='none' pad={{between:'small'}} style={{width:'80%', padding: '0px 12px'}}>
                            <Heading tag='h5' strong={true} margin='none'>Storage</Heading>
                            <Heading tag='h5'  style={{fontWeight: '500',marginBottom:'0px'}} margin='none' > { StorageDetails } </Heading>
                            <Heading tag='h5'  style={{fontWeight: '500'}} margin='none' >  { StorageVolumeDetails } </Heading>
                        </Box>
                    </Box>
                  </Tile>   
                }             
            </Tiles>
        </Box>
        <Box margin='none' pad={{between: "small"}} >
            { DASData }
            { SANData }
        </Box> 
      </Box>
    );
  }
}

export default RecomSoln;



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/Recom_Soln.js